import { getBackgroundShade, IButtonStyles, ICheckboxStyles, IComboBoxStyles, ISeparatorStyles, ISpinButton, ISpinButtonStyles, IStyle, ITextFieldStyles, PartialTheme, Separator, Stack, ThemeProvider } from '@fluentui/react';
import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes } from 'react-router-dom';
import { InferencePriority } from 'typescript';
import MenuView from './App/Menu/MenuView';
import ConfigureService from './Services/ConfigureService'

interface IAppProps {

}

export const Layout: React.FC = props => {
    return  <Stack horizontal>
        <Stack styles={{ root: { minWidth: 200, paddingLeft: 15, paddingTop: 15, minHeight: 'calc(100vh - 258px)', borderRight: '1px lightgray solid' } }}>
            <MenuView />
        </Stack>
        <div style={{ maxWidth: 'calc(100% - 200px)', width: 'calc(100% - 200px)' }}>
                {props.children}
        </div>
      </Stack>
}
